import React, { useMemo } from "react";
import CatalogNameAutocomplete from "../../../components/UI/CatalogNameAutocomplete";
import {
  CATALOG_SEARCH_DEBOUNCE_MS,
  CATALOG_SEARCH_MIN_CHARS,
} from "../../../hooks/useDebouncedCatalogSearch";
import { rowLabelClass } from "./MultiRowFields";
import {
  getInsuranceOptionKey,
  getInsuranceOptionLabel,
  getInsuranceOptionSubtitle,
  searchInsuranceCatalog,
} from "../insuranceCatalog";

/**
 * Insurance name typeahead for patient demographics rows.
 * Pick from Libraries catalog or type a custom name (saved as-is on submit).
 */
const InsuranceNameField = ({
  label = "Insurance Name",
  value = "",
  onChange,
  required = false,
  className = "",
  error = "",
}) => {
  const searchFn = useMemo(
    () => (query, ctx) => searchInsuranceCatalog(query, ctx),
    [],
  );

  return (
    <div className={`space-y-1 min-w-0 ${className}`}>
      <label className={rowLabelClass}>
        {label} {required ? <span className="text-red-500">*</span> : null}
      </label>
      <CatalogNameAutocomplete
        value={value}
        onChange={onChange}
        onSelect={(row) => onChange?.(getInsuranceOptionLabel(row))}
        placeholder="Search or type insurance name"
        searchFn={searchFn}
        getOptionLabel={getInsuranceOptionLabel}
        getOptionKey={getInsuranceOptionKey}
        getOptionSubtitle={getInsuranceOptionSubtitle}
        debounceMs={CATALOG_SEARCH_DEBOUNCE_MS}
        minChars={CATALOG_SEARCH_MIN_CHARS}
        compact
        error={error}
      />
    </div>
  );
};

export default InsuranceNameField;
